export enum UserRole {
  ADMIN = 'ADMIN',
  LEADER = 'QA_LEAD',
  MEMBER = 'QA_MEMBER',
  AGENT = 'AGENT',
}

export enum AccessPermission {
  FULL_ACCESS = 'FULL_ACCESS',
  LIMITED_ACCESS = 'LIMITED_ACCESS',
}

export enum MemberStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
}

export interface Permission {
  permission_id: string
  permission: {
    name: string
  }
}

export interface UserWorkspaceRole {
  name: UserRole
  role_permissions: Permission[]
}

export interface UserWorkspace {
  workspace_id: string
  workspace: {
    cxg_workspace_id: string
    name: string
  }
  role: UserWorkspaceRole
}

export interface User {
  id: string
  avatar: string
  email: string
  name: string
  from_cxg: boolean
  user_workspaces: UserWorkspace[]
}

export interface GetAllMembersResponseType {
  workspace_id: string
  user: Omit<User, 'from_cxg' | 'user_workspaces'>
  role: Pick<UserWorkspaceRole, 'name'>
}

export type UpdateUserPayload = {
  avatar?: string
  name?: string
  email?: string
}

export type ModifyMemberValues = Partial<Pick<User, 'name' | 'email'>> & {
  role?: UserRole
}

export interface GetMemberParams extends ListParams {
  // workspace_id: string;
}
